import React, { useState, useContext, useEffect } from 'react';
import Popup from 'components/common/popup/popup';
import ViewsContext from 'contexts/viewsContext';
import AppContext from 'contexts/appContext';
import { useTranslation } from 'react-i18next';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';

export default function HourlyLaborCumuTableViewGlance(props) {
  function showChart() {
    props.changeViewStateFn();
  }

  const { t } = useTranslation();
  const { viewsState, setHourlyLaborCumuTableViewConfig } = useContext(ViewsContext);
  const { appState } = useContext(AppContext);
  const [configureChartsPopupVisible, setConfigureChartsPopupVisible] = useState(false);

  const SortableItem = SortableElement(({ item }) => {
    return (
      <li className='list-group-item formmenu-child' style={{ opacity: '1 !important', visibility: 'visible !important', zIndex: '10000' }}>
        <div className='row'>
          <div className='col-1'>
            <div className='subtle draggable-handle ui-sortable-handle'><i className='icons8-braille' /></div>
          </div>
          <div className='col-9'>{t(item.title)}&nbsp;{item.title !== 'Hour' ? (item.sign) : ''}</div>
          <div className='col-2 text-right'>
            {(() => {
              switch (item.title) {
                case 'Hour': return <i className='icons8-lock' style={{ fontSize: '20px', paddingRight: '25px' }} />
                default: return (
                  <div className='custom-control custom-switch' onClick={(value) => {
                    item.isVisible = !item.isVisible;
                    setHourlyLaborCumuTableViewConfig(viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView);
                  }}>
                    <input type='checkbox' className='custom-control-input' checked={item.isVisible} />
                    <label className='custom-control-label'></label>
                  </div>
                );
              }
            })()}

          </div>
        </div>
      </li>
    );
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <div className='table-view-config'>
        <p>Edit table columns:</p>
        {items.map((value, index) => (
          <SortableItem key={`item-${value.showVar}`} index={index} item={value} />
        ))}
      </div>
    );
  });

  function onSortEnd({ oldIndex, newIndex }) {
    setHourlyLaborCumuTableViewConfig(arrayMove(viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView, oldIndex, newIndex));
  };

  return (
    <>
      <Popup title={t('ConfigureTable')} theme={appState.theme} show={configureChartsPopupVisible} onClose={() => setConfigureChartsPopupVisible(false)}>
        <div>
          <SortableList items={viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView} onSortEnd={onSortEnd} distance={2} />
        </div>
      </Popup>

      <div className={'panel panel-default glance glance-2x2 togglable togglable-table hclabor-table-view-body ' + props.viewState} >
        <div className='panel-heading hclabor-table-view-heading' >
          <div className='edge edge-left'>
            <i className='icons8-calendar-with-clock' aria-hidden='true' />
          </div>
          <div style={{ width: '80%' }}>
            <h3 className='panel-title'>{t('HourlyLabor')} - {t('Cumulative')}</h3>
          </div>
          <div className='edge edge-right'>
            <button type='button' className='btn btn-simple btn-left hclabor-table-view-btn' onClick={() => setConfigureChartsPopupVisible(true)}>
              <i className='icons8-settings' aria-hidden='true' />
            </button>
          </div>
        </div>
        <div className='panel-body table-holder'>
          <HCSTable data={props.data} />

        </div>
        <div className='panel-footer '>
          <button className='btn btn-simple btn-default btn-block btn-large hclabor-table-view-btn' onClick={showChart}>
            <i className='icons8-bar-chart-filled' style={{ borderLeft: '1px solid black', borderBottom: '1px solid black' }} />{t('ShowChart')}
          </button>
        </div>
      </div>
    </>
  );
}

export function HCSTable(props) {
  const { t } = useTranslation();
  const { viewsState, setHourlyLaborCumuTableViewConfig } = useContext(ViewsContext);
  const [currentSort, setCurrentSort] = useState('default');
  const [currentSortVar, setCurrentSortVar] = useState(null);

  useEffect(() => {
    viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView.forEach((element) => {
      element.sortDirection = 'default';
    });
    setHourlyLaborCumuTableViewConfig(viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView);
  }, []);


  const cumulativeData = (data) => {
    var result = data.map((object) => ({ ...object }))
    for (var i = 1; i < result.length; i++) {
      viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView.forEach((element) => {
        if (element.title !== 'Hour') {
          result[i][element.showVar] = Math.round((result[i][element.showVar] + result[i - 1][element.showVar]) * 100) / 100;
        }
      });
    }
    return result;
  }

  const Sort = (sortVar) => {
    viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView.forEach((element) => {
      if (element.sortVar !== sortVar) {
        element.sortDirection = 'default';
      }
      else {
        if (element.sortDirection === 'down') element.sortDirection = 'default';
        else if (element.sortDirection === 'up') element.sortDirection = 'down';
        else if (element.sortDirection === 'default') element.sortDirection = 'up';
        setCurrentSort(element.sortDirection);
        setCurrentSortVar(element.sortVar);
      }
    });
  };

  return (
    props.data.length > 0 && (
      <table className='table table-hover glance-table editable sorted'>
        <thead>
          <tr>
            {
              viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView.map((element, i) => {
                if (element.isVisible === true) {
                  if (element.title === 'Hour') {
                    return (<th key={i} className=' text-nowrap' onClick={() => Sort(element.sortVar)}>{t('Hour')}
                      <i className={`icons8-${sortTypes[element.sortDirection].class}`} />
                    </th>)
                  }
                  else {
                    return (<th key={i} className='text-right text-nowrap' onClick={() => Sort(element.sortVar)} >{t(element.title)}&nbsp;({element.sign})
                      <i className={`icons8-${sortTypes[element.sortDirection].class}`} />
                    </th>)
                  }
                }
                else {
                  return null;
                }
              })
            }
          </tr>
        </thead>
        <tbody>
          {(() => {
            return cumulativeData(props.data).sort(sortTypes[currentSort].fn(currentSortVar)).map((p, index) => (
              <tr key={index}>
                {
                  viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView.map((element, i) => {
                    if (element.isVisible === true) {
                      return (<td key={i} className={element.title !== 'Hour' ? 'text-right text-nowrap' : 'text-nowrap'}>
                        {element.sign === '$' ? '$' : ''}{p[element.showVar]}{element.sign === '%' ? '%' : ''}
                      </td>);
                    }
                    else {
                      return null;
                    }
                  })
                }
              </tr>
            ));
          })()}
        </tbody>
        <tfoot>
          <tr key='total' className='total'>
            {
              viewsState.chartsAndTableViewsConfigs.hourlyLaborCumuTableView.map((element, i) => {
                if (element.isVisible === true) {
                  if (element.title === 'Hour') {
                    return (<td key={i} className=' '>{t('Total')}</td>)
                  }
                  else {
                    return (<td key={i} className='text-right'>
                      {element.sign === '$' ? '$' : ''}
                      {(props.data.map((item) => item[element.showVar]).reduce((prev, next) => prev + next)).toFixed(2)}
                      {element.sign === '%' ? '%' : ''}
                    </td>)
                  }
                }
                else {
                  return null;
                }
              })
            }
          </tr>
        </tfoot>
      </table>
    )
  );
}

const sortTypes = {
  up: {
    class: 'sort-up',
    fn: (c) => (a, b) => a[c] - b[c]
  },
  down: {
    class: 'sort-down',
    fn: (c) => (a, b) => b[c] - a[c]
  },
  default: {
    class: 'nosort',
    fn: (c) => (a, b) => a[c]
  }
};